export let STEPS = /*#__PURE__*/function (STEPS) {
  STEPS["BEFORE_APPROVING_MOCKUP"] = "BEFORE_APPROVING_MOCKUP";
  STEPS["APPROVE_MOCKUP"] = "APPROVE_MOCKUP";
  return STEPS;
}({});